import { z } from "zod";

import {
  mobileNumberSchema,
  mobileNumberVerificationSchema,
  teamMemberNamesAndEmailSchema,
  termsAndConditionsSchema,
} from "~/common/utils/signUpSchemas";
import { passwordSchema } from "./ProviderSchemas";

export const teamMemberSignUpSchema = z.object({
  namesAndEmail: teamMemberNamesAndEmailSchema,
  termsAndConditions: termsAndConditionsSchema,
  mobileNumber: mobileNumberSchema,
  verification: mobileNumberVerificationSchema,
  password: passwordSchema,
});

export type TeamMemberSignUpSchemaType = z.infer<typeof teamMemberSignUpSchema>;
